import ActivityRefundDetail from "@/pages/ActivityRefundDetail.vue"; // 活动退费详情
import ActivityRefundList from "@/pages/ActivityRefundList.vue"; // 活动退费列表
import CompensateList from "@/pages/CompensateList.vue";
import CompensateListDetail from "@/pages/CompensateListDetail.vue";
import Home from "@/pages/Home.vue";
import Login from "@/pages/Login.vue";
import PurchaseOrderDetail from "@/pages/PurchaseOrderDetail.vue";
import PurchaseOrderGoodsList from "@/pages/PurchaseOrderGoodsList.vue";
import PurchaseOrderList from "@/pages/PurchaseOrderList.vue";
import PurchaseOrderList2 from "@/pages/PurchaseOrderList2.vue";
import PurchasePlanDetail from "@/pages/PurchasePlanDetail.vue";
import PurchasePlanList from "@/pages/PurchasePlanList.vue";
import PurchaseRefundDetail from "@/pages/PurchaseRefundDetail.vue";
import PurchaseRefundList from "@/pages/PurchaseRefundList.vue";
import ReturnAndExchangeDetail from "@/pages/ReturnAndExchangeDetail.vue";
import ReturnAndExchangeList from "@/pages/ReturnAndExchangeList.vue";
import StockInList from "@/pages/StockInList.vue";
import FirstAidKitList from "@/pages/firstAidKit/FirstAidKitList.vue";

import AdminGroupTree from "@/pages/AdminGroupTree.vue";
import AdminList from "@/pages/AdminList.vue";
import AdminListToGroup from "@/pages/AdminListToGroup.vue";
import AdminRoleTree from "@/pages/AdminRoleTree.vue";
import AfterSalesDetail from "@/pages/AfterSalesDetail.vue"; // 售后详情
import AfterSalesList from "@/pages/AfterSalesList.vue"; // 售后列表
import CommonLog from "@/pages/CommonLog.vue";
import MarkingLogList from "@/pages/MarkingLogList.vue";
import ModifiedPurchasePriceLogList from "@/pages/ModifiedPurchasePriceLogList.vue";
import PurchaseDeduction from "@/pages/PurchaseDeduction.vue";
import PurchaseGoodsToBeReturned from "@/pages/PurchaseGoodsToBeReturned.vue";
import PurchaseReport from "@/pages/PurchaseReport.vue";
// 履约报表模块
import PerformanceReportDetail from "@/pages/PerformanceReport/PerformanceReportDetail.vue";
import PerformanceReport from "@/pages/PerformanceReport/index.vue";

import PurchaseReportDetail from "@/pages/PurchaseReportDetail.vue";
import StockDetail from "@/pages/StockDetail.vue";
import StockoutRecord from "@/pages/StockoutRecord.vue";
import TallyReportList from "@/pages/TallyReportList.vue";
import Tallying from "@/pages/Tallying.vue";
import TallyingDetail from "@/pages/TallyingDetail.vue";
import WarehousingList from "@/pages/WarehousingList.vue";
import EditPlan from "@/pages/wcgplan/EditPlan.vue";
// import PurchaseJiezhuan from '@/pages/PurchaseJiezhuan'
import CacheDevice from "@/pages/CacheDevice.vue";
import DeductionCollect from "@/pages/DeductionCollect.vue";
import DeductionDetail from "@/pages/DeductionDetail.vue";
import OrderVerifyLog from "@/pages/OrderVerifyLog.vue";
import PurchaseAllBrokenDebts from "@/pages/PurchaseAllBrokenDebts.vue"; // 坏账状态列表
import PurchaseCgBrokenDebts from "@/pages/PurchaseCgBrokenDebts.vue"; // 转坏账代采
import PurchaseCkBrokenDebts from "@/pages/PurchaseCkBrokenDebts.vue"; // 转坏账仓库
import PurchaseCwBrokenDebts from "@/pages/PurchaseCwBrokenDebts.vue"; // 转坏账财务
import PurchaseOrderEdit from "@/pages/PurchaseOrderEdit.vue";
import PurchaseStagnantDebts from "@/pages/PurchaseStagnantDebts.vue"; // 转呆账
import PurchaseStockIn from "@/pages/PurchaseStockIn.vue"; // 代采入库
import ReimbursementList from "@/pages/ReimbursementList.vue";
import SelectGoodsList from "@/pages/SelectGoodsList.vue";
import RejectList from "@/pages/reject/RejectList.vue"; /* 退换货列表 */
import RejectStatement from "@/pages/reject/RejectStatement.vue"; /* 退换货报表 */
import AddSupply from "@/pages/supply/AddSupply.vue"; // 商家列表
import AddSupplyByApply from "@/pages/supply/AddSupplyByApply.vue"; // 创建商家(待合作商家)
import BaobUsageData from "@/pages/supply/BaobUsageData.vue"; // 爆版使用情况报表
import OnlineContractManagement from "@/pages/supply/OnlineContractManagement.vue"; // 线上合同签署管理
import SupplyDailyPaper from "@/pages/supply/SupplyDailyPaper.vue"; // 档口日账单
import SupplyList from "@/pages/supply/SupplyList.vue"; // 商家列表
import UpdateSupply from "@/pages/supply/UpdateSupply.vue"; // 商家列表

import DaBiaoHistoryList from "@/pages/DaBiaoHistory.vue"; // 打标历史轨迹
import ShareText from "@/pages/ShareText.vue"; // 代采版分享内容设置
import HexiaoList from "@/pages/hexiaoList.vue"; // 核销列表
import DayMonitorList from "@/pages/monitor/DayMonitor.vue"; // 每日业务监控
import NoDataGoodsList from "@/pages/nodatagoods/NoDataGoodsList.vue"; /* 无数据商品列表 */
import BatchOrderFencang from "@/pages/order/batchOrderFencang.vue"; // Excel发货
import WaitShipList from "@/pages/order/waitShipList.vue"; // Excel发货,上传列表
import NeedShipping from "@/pages/orderinfos/NeedShipping.vue"; // 已配需发货列表
import PurchaseGroupAdd from "@/pages/purchasegroup/AddPGroup.vue"; // 代采组新增
import Purchase from "@/pages/purchasegroup/Purchase.vue"; // 代采组列表
import PurchaseGroupUpdate from "@/pages/purchasegroup/UpdatePGroup.vue"; // 代采组详情
import WaitingPurchase from "@/pages/purchaseverify/WaitingPurchase.vue"; // 待开单商家列表
import WaitingPurchaseDetail from "@/pages/purchaseverify/WaitingPurchaseDetail.vue"; // 待开单商家详情
import PurchaseAppVersionSetting from "@/pages/setting/PurchaseAppVersionSetting.vue";
import WarehouseAppVersionSetting from "@/pages/setting/WarehouseAppVersionSetting.vue";
import SpaceList from "@/pages/space/SpaceList.vue"; // 仓位管理
import SupplyAddNew from "@/pages/supply/AddNew.vue"; // 商品详情图查看
import SupplyCooperation from "@/pages/supply/Cooperation.vue"; // 商家入驻列表
import SupplyProfile from "@/pages/supply/Profile.vue"; // 商家画像
import SupplyLog from "@/pages/supply/SupplyLog.vue"; // 档口助手操作日志
import SupplyStyles from "@/pages/supply/SupplyStyles.vue"; // 商家风格
import OkSupplyBill from "@/pages/supplybill/OkSupplyBill.vue"; // 已完成账单列表
import OkSupplyBillDetail from "@/pages/supplybill/OkSupplyBillDetail.vue"; // 已完成账单列表详情
import ReportDetail from "@/pages/supplybill/ReportDetail.vue";
import SupplyBill from "@/pages/supplybill/SupplyBill.vue"; // 商家账单
import SupplyBillDetail from "@/pages/supplybill/SupplyBillDetail.vue"; // 商家账单详情
import SupplyXhhkReport from "@/pages/supplybill/SupplyXhhkReport.vue";
import ImagesOfGoods from "@/pages/warehousetool/ImagesOfGoods.vue"; // 商品详情图查看
import WavePickingCheck from "@/pages/wavepicking/Check.vue";
import Check1 from "@/pages/wavepicking/Check1.vue";
import WavePickingPrintDevices from "@/pages/wavepicking/PrintDevices.vue"; // 波次打印机
import PrintWavePicking from "@/pages/wavepicking/PrintWavePicking.vue"; // 打印波次单
import SplitWavePicking from "@/pages/wavepicking/SplitWavePicking.vue";
import VerifyLog from "@/pages/wavepicking/VerifyLog.vue"; // 校验日志列表
import WavePickingCheckLogList from "@/pages/wavepicking/WavePickingCheckLogList.vue"; // 快递校验列表
import WavePickingInfo from "@/pages/wavepicking/WavePickingInfo.vue"; // 波次单详情列表
import WavePickingList from "@/pages/wavepicking/WavePickingList.vue"; // 波次单列表
import WavePickingSender from "@/pages/wavepicking/WavePickingSender.vue"; // 寄件人
import WavePickingSetting from "@/pages/wavepicking/WavePickingSetting.vue"; // 波次配置
import WavePickingSummaryInfo from "@/pages/wavepicking/WavePickingSumaryInfo.vue"; // 汇总单详情
import ScheduleList from "@/pages/wcgplan/ScheduleList.vue";
import WorkList from "@/pages/work/WorkList.vue"; /* 工单列表 */
// import AbnormalWorkList from '@/pages/work/AbnormalWorkList';//异常工单
// import NoDataWorkList from '@/pages/work/NoDataWorkList'; //无数据工单
import SqlNoticeSetting from "@/pages/setting/SqlNoticeSetting.vue"; // sql提醒功能
import SupplyPackageList from "@/pages/supply/SupplyPackageList.vue";
import Work from "@/pages/work/Work.vue";
// 售后波次
import AsWavePickingInfo from "@/pages/aswavepicking/AsWavePickingInfo.vue"; // 波次单详情列表
import AsWavePickingList from "@/pages/aswavepicking/AsWavePickingList.vue"; // 波次单列表

import PickerList from "@/pages/picker/PickerList.vue";
import QualityCheck from "@/pages/quality/Check.vue";
import QualityList from "@/pages/quality/QualityList.vue";
import Version from "@/pages/setting/Version.vue";
import ShippingRule from "@/pages/wavepicking/ShippingRule/ShippingRule.vue"; // 快递设置

import GbLog from "@/pages/GaiBiao/GbLog.vue"; // 改标日志
import OperateRecordExport from "@/pages/OperateRecordExport.vue"; // 操作日志导出
import PcTrans from "@/pages/PcTrans.vue"; // PC调拨
import ScanDbidsList from "@/pages/ScanDbidsList.vue"; // 扫码达人
import UpshelfDetail from "@/pages/UpshelfDetail.vue"; // 上架单详情
import UpshelfList from "@/pages/UpshelfList.vue"; // 上架单列表
import QualityLabelSetting from "@/pages/adminsetting/QualityLabelSetting.vue"; // 质检改标设置
import MerchantClaimsOrderList from "@/pages/merchantClaimsOrder/index.vue"; // 商家发货慢-赔付单
import MerchantClaimsDetail from "@/pages/merchantClaimsOrder/detail.vue"; // 商家发货慢-赔付单详情
import MerchantMarginAccount from "@/pages/merchantMarginAccount/index.vue"; // 商家保证金账户列表
import MerchantMarginAccountFlowLog from "@/pages/merchantMarginAccount/flowLog.vue"; // 商家保证金保证金账户流水日志
import ClaimsList from "@/pages/claims/ClaimsList.vue"; // 理赔列表
import ClaimsDetail from "@/pages/claims/Detail.vue"; // 理赔详情
import ClaimsIndex from "@/pages/claims/Index.vue"; // 待理赔列表
import CodCheckList from "@/pages/cod/checkList.vue"; // 货到付款审核列表
import CodDenyList from "@/pages/cod/denyList.vue"; // 货到付款拒签列表
import CodIndex from "@/pages/cod/index.vue";
import DeviceCutLog from "@/pages/devicecut/index.vue"; // 分播日志
import DownshelfDetail from "@/pages/downshelf/detail.vue"; //  整合单详情
import DownshelfIndex from "@/pages/downshelf/index.vue"; // 整合单列表
import InventoryDetail from "@/pages/inventory/Detail.vue"; // 盘点详情
import InventoryLog from "@/pages/inventory/InventoryLog.vue"; // 盘点日志
import InventoryList from "@/pages/inventory/List.vue"; // 盘点列表
import OrderStopLogList from "@/pages/log/OrderStopLogList.vue"; // 订单断货日志
import OweExceptionList from "@/pages/log/OweExceptionList.vue"; // 欠货异常操作日志列表
import MachineCut from "@/pages/machine/machineCut.vue"; // 分播机器列表监控
import MachineList from "@/pages/machine/machineList.vue"; // 分播机器列表
import PayOrderList from "@/pages/payorder/PayOrderList.vue"; // 银行转账记录
import ImportantSupplyLog from "@/pages/picker/ImportantSupplyLog.vue"; // 买手绑档操作日志
import PerformanceBoard from "@/pages/picker/PerformanceBoard.vue"; // 买手商运绩效看板
import StockDetailList from "@/pages/stockdetail/StockDetalList.vue"; // 库存明细
import BoxIndex from "@/pages/storagebox/index.vue";
import PackageDetail from "@/pages/supply/PackageDetail.vue"; // 质检调拨改排
import ProfileManager from "@/pages/supply/ProfileManager.vue"; // 档口小程序人员管理
import UpshelfLog from "@/pages/upshelf/UpshelfLog.vue"; // 上架日志
import WaveCheckSetting from "@/pages/wavepicking/CheckSetting.vue"; // 波次校验设置
import WaveCutSetting from "@/pages/wavepicking/CutSetting.vue"; // 波次分播设置
import DaBiaoSetting from "@/pages/wavepicking/DaBiaoSetting.vue"; // 点货设置
import DeviceCut from "@/pages/wavepicking/DeviceCut.vue";
import GridSetting from "@/pages/wavepicking/GridSetting.vue";
import LabelUserSetting from "@/pages/wavepicking/LabelUserSetting.vue"; // 改标用汇总设置
import LabelUserSpace from "@/pages/wavepicking/LabelUserSpace.vue"; // 改标用汇总设置
import OnlyDabiaoSetting from "@/pages/wavepicking/OnlyDabiaoSetting.vue"; // 单件分离今日配齐设置
import PdaSetting from "@/pages/wavepicking/PdaSetting.vue"; // pad设置
import QlSummaryDetail from "@/pages/wavepicking/QlSummaryDetail.vue"; // 临时汇总
import StockDetailErrorDetail from "@/pages/wavepicking/StockDetailErrorDetail.vue"; // 库存异常明细
import StockDetailSeparateSetting from "@/pages/wavepicking/StockDetailSeparateSetting.vue"; // 点货库存分离设置
import SummaryCut from "@/pages/wavepicking/SummaryCut.vue";
import SummarySetting from "@/pages/wavepicking/SummarySetting.vue"; // 波次汇总配置
import TempSummaryList from "@/pages/wavepicking/TempSummaryList.vue"; // 临时汇总
import TempYcSpaceList from "@/pages/wavepicking/TempYcSpaceList.vue"; // 临时异常列表
import WavePickingHechaLog from "@/pages/wavepicking/WavePickingHechaLog.vue"; // 波次核查日志
import WeighTurnSetting from "@/pages/wavepicking/WeighTurnSetting.vue"; // 称重转向配置
import FreezenBillList from "@/pages/xhhk/FreezenBillList.vue";
import YkbFlowdetailList from "@/pages/ykbFlowdetail/YkbFlowdetailList.vue"; // 银行转账记录

import DbidTravelLog from "@/pages/DbidTravelLog.vue"; // 商品全轨迹查询
import GbInputRecord from "@/pages/GaiBiao/GbInputRecord.vue"; // 改标录入列表
import GbTypeSetting from "@/pages/GaiBiao/GbTypeSetting.vue"; // 改标类型管理
import GbUserSetting from "@/pages/GaiBiao/GbUserSetting.vue"; // 改标人员管理
import AsPackageDetail from "@/pages/aspackage/AsPackageDetail.vue"; // 售后收包列表详情
import AsPackageIntercept from "@/pages/aspackage/AsPackageIntercept.vue"; // 售后收包拦截
import AsPackageList from "@/pages/aspackage/AsPackageList.vue"; // 售后收包列表
import DefectiveGroup from "@/pages/defectivegroup/index.vue"; // 次品组别
import ErpErrorLog from "@/pages/log/ErpErrorLog.vue"; // 错误操作日志列表
import PlanOperLogList from "@/pages/log/PlanOperLogList.vue"; // 急救箱日志
import LogisticsList from "@/pages/logistics/logisticsList.vue"; // 物流公司列表
import ScreenBoard from "@/pages/monitorscreen/Board.vue"; // 监控看板
import BaobLicence from "@/pages/setting/BaobLicence.vue"; // 爆版入驻许可编辑
import ExpressSizeSetting from "@/pages/setting/ExpressSize.vue"; // 快递尺寸设置
import SupplyPackageTips from "@/pages/setting/SupplyPackageTips.vue"; // 仓储收包商家提示
import TallyTaskSetting from "@/pages/setting/TallyTaskSetting.vue"; // 理货任务配置
import ExchangeList from "@/pages/stocking/ExchangeList.vue"; // 次品组退换货接收
import SupplyNoticeList from "@/pages/supply/SupplyNoticeList.vue"; // 商家消息公告
import SupplyWaitBackList from "@/pages/supplywaitback/SupplyWaitBackList.vue"; // 商家待回货商品
import TallyTaskDetail from "@/pages/tallytask/TallyTaskDetail.vue"; // 理货任务详情
import TallyTaskList from "@/pages/tallytask/TallyTaskList.vue"; // 理货任务列表
import RecheckLogDetail from "@/pages/wavepicking/RecheckLogDetail.vue"; // 核查日志详情
import RecheckLogList from "@/pages/wavepicking/RecheckLogList.vue"; // 核查日志列表

import MerchantsIndex from "@/pages/merchants/index.vue"; // 意向商家列表
import PaCashLogList from "@/pages/pacashlog/PaCashLogList.vue"; // 平安提现充值记录
import PreAllotList from "@/pages/preallot/preAllotList.vue";
import RefundBillList from "@/pages/refundBill/RefundBillList.vue"; // 返还资金流水

import VendorProfitConcessionDetail from "@/pages/VendorProfitConcessionDetail/VendorProfitConcessionDetail.vue";
import VendorProfitConcessionList from "@/pages/VendorProfitConcessionList/VendorProfitConcessionList.vue";
import GoodsIntegration from "@/pages/setting/GoodsIntegration.vue";
import ShowSupply from "@/pages/supply/ShowSupply.vue";
import SupplyDetail from "@/pages/supply/SupplyDetail.vue";
import SupplyApplyList from "@/pages/supplyapply/SupplyApplyList.vue";
import MerchantServiceScore from "@/pages/supply/businessGovernanceManag/merchantServiceScore/index.vue"; // 商家服务分
import SupplyApplyListPro from "@/pages/supplyapply/SupplyApplyListPro.vue";
import afterSale from "@/router/routes/afterSale.js"; // 商品预配订单表
import goods from "@/router/routes/goods.js"; // 商品管理
import inventory from "@/router/routes/inventory.js"; // 盘点
import log from "@/router/routes/log.js"; // 日志
import quality from "@/router/routes/quality.js"; // 质检
import receiveGoods from "@/router/routes/receiveGoods.js"; // 收货管理
import supplyNotice from "@/router/routes/supplyNotice.js"; // 商家消息通知相关
import warehouse from "@/router/routes/warehouse.js"; // 仓库
import warehouseTransfer from "@/router/routes/warehouseTransfer.js"; // 跨仓调拨
import { mergeRouter } from "@/tool/helper.js";
import finance from "./finance.js";
import hotStockingRouter from "./hotStockingRouter.js";
import oweReback from "./oweReback.js"; //  恢复欠货相关
import preSpaceRouter from "./preStorageRouter.js";
import randOut from "./randOut.js"; // 随出
import reCommodityRouter from "./reCommodityRouter.js";
import returnOrder from "./returnOrder.js"; // 退供单相关
import serviceOrder from "./serviceOrder.js"; //  售后工单
import setting from "./setting.js";
import stockDetail from "./stockDetail.js"; // 库存相关
import supply from "./supply.js"; //  商家相关
import tallyRouter from "./tallyRouter.js";
import task from "./task.js";
import wavePickingRouter from "./wavePicking.js"; //  波次相关
import workRouter from "./work.js"; // 售后相关

import MerchantMarketingAccount from "@/pages/MerchantMarketingAccount/MerchantMarketingAccount.vue"; // 商家营销账号
import MerchantMarketingAccountLog from "@/pages/MerchantMarketingAccount/MerchantMarketingAccountLog.vue"; // 商家营销账号-查看日志
import MerchantOperator from "@/pages/picker/MerchantOperator.vue"; // 商家运营人员管理
import Positions from "@/pages/positionPermissions/Positions.vue"; // 岗位权限
import PositionsCreate from "@/pages/positionPermissions/PositionsCreate.vue"; // 新建岗位

import Overdue from "@/pages/Overdue.vue";
import stock from "@/router/routes/stock.js";
// 超过三天未发货
const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/wavepicking/printwavepicking/:id/:note/:origin", // 打印波次单
    name: "PrintWavePicking",
    component: PrintWavePicking,
    meta: {
      requireAuth: true,
    },
  },

  // 打印改标汇总单 旧码新用 2019.11.16
  {
    path: "/wavepickingsummary/printall/:id",
    name: "PrintAll",
    component: () => import("@/pages/wavepicking/TempPrintAll.vue"),
    meta: {
      requireAuth: true,
    },
  },

  // 拣货任务打印
  {
    path: "/picking/PickingTaskPrint/:task_ids?",
    name: "PickingTaskPrint",
    component: () => import("@/pages/picking/PickingTaskPrint.vue"),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的,除了登录页面所有页面都需要这个
    },

    children: [
      // home下面都需要登陆 在main.js有判断 /home为url前缀的都强制登陆 所以 下面的路由都可以不用加 requireAuth: true

      {
        path: "purchasing/purchaseorderlist", // 代采订单列表
        name: "purchaseorderlist",
        component: PurchaseOrderList,
        meta: {
          title: "代采订单列表",
        },
      },
      {
        path: "purchasing/purchaseorderlist2", // 计划外-已垫付代采订单列表
        name: "purchaseorderlist2",
        component: PurchaseOrderList2,
        meta: {
          title: "已垫付代采单",
        },
      },
      {
        path: "purchasing/purchaseordergoodslist", // 代采订单列表
        name: "purchaseordergoodslist",
        component: PurchaseOrderGoodsList,
        meta: {
          title: "代采单商品列表",
        },
      },
      {
        path: "purchasing/resetBillLog",
        name: "purchaseorderResetBillLog",
        component: () => import("../pages/log/ResetBillLog.vue"),
        meta: {
          title: "重置开单日志",
        },
      },
      {
        path: "purchasing/purchaseplanlist", // 代采计划列表
        name: "purchaseplanlist",
        component: PurchasePlanList,
        meta: {
          title: "代采计划列表",
        },
      },
      {
        path: "firstaidkit/firstaidkitlist", // 急救箱列表
        name: "firstAidKitList",
        component: FirstAidKitList,
        meta: {
          title: "急救箱列表",
        },
      },
      {
        path: "purchaseplandetail/:id", // 代采计划详情
        name: "purchaseplandetail",
        component: PurchasePlanDetail,
        meta: {
          title: "代采计划详情",
        },
      },
      {
        path: "purchaseorderdetail/:id", // 代采订单详情
        name: "purchaseorderdetail",
        component: PurchaseOrderDetail,
        meta: {
          title: "代采订单详情",
        },
      },
      {
        path: "purchasing/returnbarterlist", // 退换货列表
        name: "returnandexchangelist",
        component: ReturnAndExchangeList,
        meta: {
          title: "退换货-列表",
        },
      },
      {
        path: "returnandexchangedetail/:id", // 退换货详情
        name: "returnandexchangedetail",
        component: ReturnAndExchangeDetail,
        meta: {
          title: "退换货详情",
        },
      },
      {
        path: "purchasing/refundlist", // 退款列表
        name: "refundlist",
        component: PurchaseRefundList,
        meta: {
          title: "退款-审核列表",
        },
      },
      {
        path: "purchasing/activityRefundList", // 活动费用退费列表
        name: "activityRefundList",
        component: ActivityRefundList,
        meta: {
          title: "活动费用退费列表",
        },
      },
      {
        path: "purchasing/activityRefundList/detail/:id", // 活动费用退费列表
        name: "activityRefundDetail",
        component: ActivityRefundDetail,
        meta: {
          title: "活动费用退费详情",
        },
      },
      {
        path: "purchaserefunddetail/:id", // 退款详情
        name: "purchaserefunddetail",
        component: PurchaseRefundDetail,
        meta: {
          title: "退款详情",
        },
      },
      {
        path: "storage/stockinrecord/:pg_member_id?/:data_time?/:origin?/:p?", // 入库列表
        name: "stockinlist",
        component: StockInList,
        meta: {
          title: "商品入库日志",
        },
      },
      {
        path: "storage/compensatelist", // 赔付审核列表
        name: "Compensatelist",
        component: CompensateList,
        meta: {
          title: "赔付审核列表",
        },
      },
      {
        path: "storage/compensatelist/:id", // 赔付审核列表详情
        name: "compensatelistdetail",
        component: CompensateListDetail,
        meta: {
          title: "赔付审核详情",
        },
      },
      {
        path: "stockdetail/:id", // 库存详情
        name: "stockdetail",
        component: StockDetail,
        meta: {
          title: "商品库存明细",
        },
      },
      {
        path: "storage/stockoutrecord", // 出库列表
        name: "stockoutrecord",
        component: StockoutRecord,
        meta: {
          title: "商品出库日志",
        },
      },
      {
        path: "adminroletree", // 角色管理
        name: "adminroletree",
        component: AdminRoleTree,
        meta: {
          title: "角色权限",
        },
      },
      {
        path: "admingrouptree", // 分组管理
        name: "admingrouptree",
        component: AdminGroupTree,
        meta: {
          title: "分组管理",
        },
      },
      {
        path: "adminlist", // 管理员列表
        name: "adminlist",
        component: AdminList,
        meta: {
          title: "管理员列表",
        },
      },
      {
        path: "adminlisttogroup", // 管理员分组列表
        name: "adminlisttogroup",
        component: AdminListToGroup,
        meta: {
          title: "管理员分组",
        },
      },
      {
        path: "storage/warehousinglist", // 待入库列表
        name: "warehousinglist",
        component: WarehousingList,
        meta: {
          title: "待入库列表",
        },
      },
      {
        path: "storage/markingloglist", // 打标日志列表
        name: "markingloglist",
        component: MarkingLogList,
        meta: {
          title: "打标日志",
        },
      },
      {
        path: "storage/stockdetailexcetion", //
        name: "stockdetailexcetion",
        component: StockDetailErrorDetail,
        meta: {
          title: "库存异常明细",
        },
      },
      {
        path: "purchasing/modifiedpurchasepriceloglist", // 修改代采价操作列表
        name: "modifiedpurchasepriceloglist",
        component: ModifiedPurchasePriceLogList,
        meta: {
          title: "修改代采价操作列表",
        },
      },
      {
        path: "purchasing/editplan", // 数据表格列表
        name: "editplan-list",
        component: EditPlan,
        meta: {
          title: "新建手动计划",
        },
      },
      {
        path: "purchasing/editplan/:is_early_plan", // 数据表格列表
        name: "editplan-detail",
        component: EditPlan,
        meta: {
          title: "新建提前代采计划",
        },
      },
      {
        path: "storage/tallying", // 点货
        name: "tallying",
        component: Tallying,
        meta: {
          title: "点货单",
        },
      },
      {
        path: "storage/tallyingdetail/:id", // 点货详情
        name: "tallyingdetail",
        component: TallyingDetail,
        meta: {
          title: "点货详情",
        },
      },
      {
        path: "storage/tallyreportlist", // 点货举报
        name: "tallyreportlist",
        component: TallyReportList,
        meta: {
          title: "点货举报",
        },
      },

      {
        path: "purchasing/report", // 代采报表
        name: "purchasereport",
        component: PurchaseReport,
        meta: {
          title: "代采报表",
        },
      },
      {
        path: "purchasing/performanceReport", // 履约报表
        name: "performanceReport",
        component: PerformanceReport,
        meta: {
          title: "履约报表",
        },
      },
      {
        path: "purchasing/performanceReportDetail", //  履约报表详情
        name: "performanceReportDetail",
        component: PerformanceReportDetail,
        meta: {
          title: "履约报表详情",
        },
      },
      {
        path: "purchasing/stagnantdebts", // 转呆账
        name: "purchasestagnantdebts",
        component: PurchaseStagnantDebts,
        meta: {
          title: "呆账商品列表",
        },
      },
      {
        path: "purchasing/cgbrokendebts", // 转坏账 代采
        name: "purchasecgbrokendebts",
        component: PurchaseCgBrokenDebts,
        meta: {},
      },
      {
        path: "purchasing/ckbrokendebts", // 转坏账 仓库
        name: "purchaseckbrokendebts",
        component: PurchaseCkBrokenDebts,
        meta: {
          title: "坏账审核列表-仓储",
        },
      },
      {
        path: "purchasing/cwbrokendebts", // 转坏账 财务
        name: "purchasecwbrokendebts",
        component: PurchaseCwBrokenDebts,
        meta: {
          title: "坏账审核列表-财务",
        },
      },
      {
        path: "purchasing/allbrokendebts", // 坏账状态列表
        name: "purchaseallbrokendebts",
        component: PurchaseAllBrokenDebts,
        meta: {
          title: "坏账商品列表",
        },
      },
      {
        path: "purchasing/stockin/:supply_id/:pgid/:type", // 已入库
        name: "purchasestockin",
        component: PurchaseStockIn,
        meta: {
          title: "代采报表-已入库",
        },
      },
      {
        path: "purchasing/reportdetail/:id", // 代采报表详情
        name: "purchasereportdetail",
        component: PurchaseReportDetail,
        meta: {
          title: "代采报表详情",
        },
      },

      {
        path: "purchasing/reportdetail2/:id/:goods_no", // 代采报表详情 有货号
        name: "purchasereportdetail2",
        component: PurchaseReportDetail,
        meta: {
          title: "代采报表详情",
        },
      },
      {
        path: "purchasing/reportdetail3/:id/:goods_kh", // 代采报表详情 有款号
        name: "purchasereportdetail3",
        component: PurchaseReportDetail,
        meta: {
          title: "代采报表详情",
        },
      },
      {
        path: "purchasing/reportdetail4/:id/:goods_no/:goods_kh", // 代采报表详情 有款号和款号
        name: "purchasereportdetail4",
        component: PurchaseReportDetail,
        meta: {
          title: "代采报表详情",
        },
      },
      {
        path: "storage/aftersaleslist", // 售后列表
        name: "aftersaleslist",
        component: AfterSalesList,
        meta: {
          title: "售后列表",
        },
      },
      {
        path: "storage/aftersalesdetail/:id", // 售后详情
        name: "aftersalesdetail",
        component: AfterSalesDetail,
        meta: {
          title: "售后详情",
        },
      },
      {
        path: "log/logList",
        name: "log",
        component: CommonLog,
        meta: {
          title: "公共日志列表",
        },
      },
      {
        path: "purchasing/deduction",
        name: "deduction",
        component: PurchaseDeduction,
        meta: {
          title: "商品抵扣列表",
        },
      },
      {
        path: "supply/dedcollect", // 商家抵扣汇总
        name: "dedcollect",
        component: DeductionCollect,
        meta: {
          title: "商家抵扣汇总",
        },
      },
      {
        path: "supply/deddetail/:supply_id", // 商家抵扣详情
        name: "deddetail",
        component: DeductionDetail,
        meta: {
          title: "商家抵扣详情",
        },
      },
      {
        path: "purchasing/goodstobereturned",
        name: "goodstobereturned",
        component: PurchaseGoodsToBeReturned,
        meta: {
          title: "商品欠货列表",
        },
      },

      {
        path: "purchasing/orderedit/:id", // 编辑代采单页面
        name: "purchaseorderedit",
        component: PurchaseOrderEdit,
        meta: {
          title: "新建/编辑计划外代采单",
        },
      },
      {
        path: "purchasing/selectgoods/", // 编辑代采单页面
        name: "selectgoodslist",
        component: SelectGoodsList,
        meta: {
          title: "选择商品", // ??? 不知道有什么用
        },
      },
      {
        path: "purchasing/ReimbursementList/", // 代采报销单列表页
        name: "reimbursementlist",
        component: ReimbursementList,
        meta: {
          title: "垫付报销单列表",
        },
      },
      {
        path: "order/orderVerifyLog", // 订单出库校验日志
        name: "orderVerifyLog",
        component: OrderVerifyLog,
        meta: {
          title: "垫付报销单列表",
        },
      },

      {
        path: "fresh/cachedevice", // 清除app绑定限制 cache
        name: "CacheDevice",
        component: CacheDevice,
        meta: {
          title: "清除帐号设备绑定",
        },
      },
      {
        path: "supply/supplylist/:company_name?", // 商家列表
        name: "SupplyList",
        component: SupplyList,
        meta: {
          title: "商家列表",
        },
      },
      {
        path: "supply/merchantServiceScore",
        name: "merchantServiceScore",
        component: MerchantServiceScore,
        meta: {
          title: "商家服务分",
        },
      },
      {
        path: "supply/supplyApplyList",
        name: "supplyApplyList",
        component: SupplyApplyList,
        meta: {
          title: "商家建档申请",
        },
      },
      {
        path: "supply/supplyApplyListPro",
        name: "SupplyApplyListPro",
        component: SupplyApplyListPro,
        meta: {
          title: "商家建档申请（新）",
        },
      },
      {
        path: "supply/supplyDetail/:id",
        name: "SupplyDetail",
        component: SupplyDetail,
        meta: {
          title: "商家资料（新）",
        },
      },
      {
        path: "supply/baobusagedata",
        name: "BaobUsageData",
        component: BaobUsageData,
        mete: {
          title: "爆版使用情况报表",
        },
      },
      {
        path: "supply/supplydailypaper", // 档口日账单
        name: "SupplyDailyPaper",
        component: SupplyDailyPaper,
        meta: {
          title: "档口日账单",
        },
      },
      {
        path: "supply/addsupply", // 添加商家
        name: "AddSupply",
        component: AddSupply,
        meta: {
          title: "添加商家",
        },
      },
      {
        path: "supply/AddSupplyByApply/:id", // 创建商家(待合作商家申请页)
        name: "AddSupplyByApply",
        component: AddSupplyByApply,
        meta: {
          title: "创建商家",
        },
      },
      {
        path: "supply/updatesupply/:id", // 更新商家
        name: "UpdateSupply",
        component: UpdateSupply,
        meta: {
          title: "更新商家",
        },
      },
      {
        path: "supply/showsupply/:id", // 查看商家
        name: "ShowSupply",
        component: ShowSupply,
        meta: {
          title: "查看商家",
        },
      },
      {
        path: "supply/profile/:id", // 商家画像
        name: "SupplyProfile",
        component: SupplyProfile,
        meta: {
          title: "商家画像",
        },
      },
      {
        path: "supply/styles", // 商家风格
        name: "SupplyStyles",
        component: SupplyStyles,
        meta: {
          title: "商家风格",
        },
      },
      {
        path: "supply/online-contract-management", // 商家风格
        name: "OnlineContractManagement",
        component: OnlineContractManagement,
        meta: {
          title: "线上合同签署管理",
        },
      },
      {
        path: "reject/rejectlist" /* 退换货列表 */,
        name: "RejectList",
        component: RejectList,
        meta: {
          title: "退换货列表",
        },
      },
      {
        path: "reject/reject-statement" /* 退换货列表 */,
        name: "RejectStatement",
        component: RejectStatement,
        meta: {
          title: "退换货报表",
        },
      },
      {
        path: "work/worklist" /* 售后工单商品列表 */,
        name: "WorkList",
        component: WorkList,
        meta: {
          title: "售后工单商品列表",
        },
      },
      {
        path: "nodatagoods/list/:pg_member_id?/:data_time?/:origin?" /* 无数据商品列表 */,
        name: "NoDataGoodsList",
        component: NoDataGoodsList,
        meta: {
          title: "无数据商品列表",
        },
      },
      {
        path: "wavepicking/wavepickinglist/:picking_assignment_no?", // 波次单列表
        name: "WavePickingList",
        component: WavePickingList,
        meta: {
          title: "波次单",
        },
      },
      {
        path: "wavepicking/wavepickinginfo/:id", // 波次单详情列表
        name: "WavePickingInfo",
        component: WavePickingInfo,
        meta: {
          title: "波次单详情",
        },
      },
      {
        path: "wavepicking/verifylog", // 波次校验日志
        name: "VerifyLog",
        component: VerifyLog,
        meta: {
          title: "波次校验日志",
        },
      },
      {
        path: "wavepicking/wavepickingsetting", // 波次配置
        name: "WavePickingSetting",
        component: WavePickingSetting,
        meta: {
          title: "仓库基本配置",
        },
      },
      {
        path: "purchasing/ShareText", // 偏好设置
        name: "ShareText",
        component: ShareText,
        meta: {
          title: "偏好设置",
        },
      },
      {
        path: "orderinfos/needshipping", // 已配需发商品列表
        name: "NeedShipping",
        component: NeedShipping,
        meta: {
          title: "已配需发商品列表",
        },
      },
      {
        path: "supply/supplylog", // 档口助手操作日志
        name: "SupplyLog",
        component: SupplyLog,
        meta: {
          title: "档口助手操作日志",
        },
      },
      {
        path: "daymonitor/getMonitorList", // 每日业务监控数据列表
        name: "DayMonitorList",
        component: DayMonitorList,
        meta: {
          title: "每日业务监控数据列表",
        },
      },
      {
        path: "purchase", // 代采组别
        name: "Purchase",
        component: Purchase,
        meta: {
          title: "代采组别",
        },
      },
      {
        path: "purchasegroup/addpgroup", // 代采组新增
        name: "PurchaseGroupAdd",
        component: PurchaseGroupAdd,
        meta: {
          title: "新增代采组",
        },
      },
      {
        path: "purchasegroup/updatepgroup/pgid/:id", // 代采组详情
        name: "PurchaseGroupUpdate",
        component: PurchaseGroupUpdate,
        meta: {
          title: "编辑代采组",
        },
      },
      {
        path: "setting/warehouseappversionsetting", // 仓储APP更新配置
        name: "WarehouseAppVersionSetting",
        component: WarehouseAppVersionSetting,
        meta: {
          title: "仓储APP更新配置",
        },
      },
      {
        path: "setting/purchaseappversionsetting", // 代采APP更新配置
        name: "PurchaseAppVersionSetting",
        component: PurchaseAppVersionSetting,
        meta: {
          title: "代采APP更新配置",
        },
      },
      {
        path: "setting/baoblicence", // 爆版入驻许可协议编辑
        name: "BaobLicence",
        component: BaobLicence,
        meta: {
          title: "爆版入驻许可协议编辑",
          requireAuth: true,
        },
      },
      {
        path: "wavepicking/printdevices", // 波次打印机
        name: "WavePickingPrintDevices",
        component: WavePickingPrintDevices,
        meta: {
          title: "打印机ip和端口",
        },
      },
      {
        path: "supplybill/:supply_id", // 商家账单
        name: "SupplyBill",
        component: SupplyBill,
        meta: {
          title: "商家账期",
        },
      },
      {
        path: "supplybilldetail/:settle_id", // 商家账单详情
        name: "SupplyBillDetail",
        component: SupplyBillDetail,
        meta: {
          title: "账期详情",
        },
      },
      {
        path: "OkSupplyBill", // 已完成商家账单
        name: "OkSupplyBill",
        component: OkSupplyBill,
        meta: {
          title: "账单列表",
        },
      },
      {
        path: "merchant-marketing-account",
        name: "MerchantMarketingAccount",
        component: MerchantMarketingAccount,
        meta: {
          title: "商家营销账户",
        },
      },
      {
        path: "merchant-marketing-account-log/:id",
        name: "MerchantMarketingAccountLog",
        component: MerchantMarketingAccountLog,
        meta: {
          title: "营销账户流水日志",
        },
      },
      {
        path: "vendor-profit-concession-list", // 商家让利佣金账单
        name: "VendorProfitConcessionList",
        component: VendorProfitConcessionList,
        meta: {
          title: "商家让利佣金账单",
        },
      },
      {
        path: "vendor-profit-concession-detail/:id", // 商家让利佣金账单
        name: "VendorProfitConcessionDetail",
        component: VendorProfitConcessionDetail,
        meta: {
          title: "商家让利佣金账单详情",
        },
      },
      {
        path: "OkSupplyBillDetail/:bill_id", // 已完商家账单详情
        name: "OkSupplyBillDetail",
        component: OkSupplyBillDetail,
        meta: {
          title: "账单详情",
        },
      },
      {
        path: "warehousetool/imagesofgoods", // 商品详情图查看
        name: "ImagesOfGoods",
        component: ImagesOfGoods,
        meta: {
          // requireAuth: true
          title: "商品详情图查看",
        },
      },
      {
        path: "purchaseverify/waitingpurchase", // 待开单商家列表
        name: "WaitingPurchase",
        component: WaitingPurchase,
        meta: {
          title: "代采核单",
        },
      },
      {
        path: "supply/addnew", // 商品详情图查看
        name: "SupplyAddNew",
        component: SupplyAddNew,
        meta: {
          title: "商家新款上架",
        },
      },
      {
        path: "supply/cooperation", // 商家入驻列表
        name: "SupplyCooperation",
        component: SupplyCooperation,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "wavePickingcheckloglist", // 快递校验列表
        name: "WavePickingCheckLogList",
        component: WavePickingCheckLogList,
        meta: {
          title: "快递交接",
        },
      },
      {
        path: "purchaseverify/waitingpurchasedetail/:pgid/:supply_id/:pgname/:supply_name/:settle_type/:planid/:is_dispense/:ptype", // 待开单商家详情
        name: "WaitingPurchaseDetail",
        component: WaitingPurchaseDetail,
        meta: {
          title: "代采核单详情",
        },
      },
      {
        path: "wavepicking/wavepickingsummaryinfo/:id", // 波次单详情列表
        name: "WavePickingSummaryInfo",
        component: WavePickingSummaryInfo,
        meta: {
          title: "波次单详情",
        },
      },
      {
        path: "wcgplan/schedulelist/:goods_no?",
        name: "ScheduleList",
        component: ScheduleList,
        meta: {
          title: "排单情况列表",
        },
      },
      {
        path: "order/batchorderfencang", // excel发货
        name: "BatchOrderFencang",
        component: BatchOrderFencang,
        meta: {
          title: "excel发货",
        },
      },
      {
        path: "dabiao/historylist",
        name: "DaBiaoHistoryList",
        component: DaBiaoHistoryList,
        meta: {
          title: "打标历史轨迹",
        },
      },
      {
        path: "order/waitshiplist", // excel发货
        name: "WaitShipList",
        component: WaitShipList,
        meta: {
          title: "待发货列表", // 这个路由好像没有用了
        },
      },
      {
        path: "space/spacelist",
        name: "SpaceList",
        component: SpaceList,
        meta: {
          title: "仓位管理",
        },
      },
      {
        path: "stock/hexiaoList",
        name: "HexiaoList",
        component: HexiaoList,
        meta: {
          title: "核销商品列表",
        },
      },
      {
        path: "report/SupplyXhhkReport", // 先货后款报表
        name: "SupplyXhhkReport",
        component: SupplyXhhkReport,
        meta: {
          title: "定期分账报表",
        },
      },
      {
        path: "report/SupplyReportDetail/:woid", // 先货后款报表
        name: "ReportDetail",
        component: ReportDetail,
        meta: {
          title: "代采订单报表详情",
        },
      },
      {
        path: "wavepicking/check", // 波次校验
        name: "WavePickingCheck",
        component: WavePickingCheck,
        meta: {
          title: "波次校验",
        },
      },
      {
        path: "wavepicking/check1", // 波次校验
        name: "Check1",
        component: Check1,
        meta: {
          title: "波次校验后置单",
        },
      },
      {
        path: "work", // 工单
        name: "work",
        component: Work,
        meta: {
          title: "异常工单",
        },
      },
      {
        path: "wavepicking/splitwavepicking/:id", // 波次拆分
        name: "SplitWavePicking",
        component: SplitWavePicking,
        meta: {
          title: "拆分波次",
        },
      },
      {
        path: "setting/SqlNoticeSetting", // 好像没用了
        name: "SqlNoticeSetting",
        component: SqlNoticeSetting,
        meta: {
          title: "sql设置?",
        },
      },
      {
        path: "supply/package-list", // 收包记录列表
        name: "SupplyPackageList",
        component: SupplyPackageList,
        meta: {
          title: "档口收包记录列表",
        },
      },
      {
        path: "supply/not-data-package-list", // 无数据包裹列表
        name: "NotDataPackageList",
        component: () => import("@/pages/supply/NotDataPackageList/index.vue"),
        meta: {
          title: "无数据包裹列表",
        },
      },
      {
        path: "supply/parcel-check-list", // 包裹核对列表
        name: "ParcelCheckList",
        component: () => import("@/pages/supply/ParcelCheckList/index.vue"),
        meta: {
          title: "包裹核对列表",
        },
      },
      {
        path: "aswavepicking/AsWavePickingList/:picking_assignment_no?", // 波次单列表
        name: "AsWavePickingList",
        component: AsWavePickingList,
        meta: {
          title: "售后波次",
        },
      },
      {
        path: "picker/list", // 买手组管理
        name: "PickerList",
        component: PickerList,
        meta: {
          title: "买手组管理",
        },
      },
      {
        path: "picker/performanceBoard", // 买手商运绩效看板
        name: "PerformanceBoard",
        component: PerformanceBoard,
        meta: {
          title: "买手商运绩效看板",
        },
      },
      {
        path: "aswavepicking/aswavepickinginfo/:id", // 波次单详情列表
        name: "AsWavePickingInfo",
        component: AsWavePickingInfo,
        meta: {
          title: "售后波次详情",
        },
      },
      {
        path: "wavepicking/shippingRule", // 快递设置
        name: "ShippingRule",
        component: ShippingRule,
        meta: {
          title: "快递设置",
        },
      },
      {
        path: "wavepicking/wavepickingsender", // 寄件人配置
        name: "WavePickingSender",
        component: WavePickingSender,
        meta: {
          title: "寄件地址配置",
        },
      },
      {
        path: "quality/check", // 质检校验
        name: "QualityCheck",
        component: QualityCheck,
        meta: {
          title: "质检修复",
        },
      },
      {
        path: "quality/qualitylist", // 质检校验
        name: "QualityList",
        component: QualityList,
        meta: {
          title: "质检列表",
        },
      },

      {
        path: "quality/pcQuality", // pc质检
        name: "pcQuality",
        component: () => import("@/pages/quality/PcQuality.vue"),
        meta: {
          title: "PC质检",
        },
      },

      {
        path: "setting/version", //
        name: "Version",
        component: Version,
        meta: {
          title: "版本更新",
        },
      },
      {
        path: "claims/index", // 待理赔列表
        name: "ClaimsIndex",
        component: ClaimsIndex,
        meta: {
          title: "退款理赔列表",
        },
      },
      {
        path: "claims/claimslist", // 理赔列表
        name: "ClaimsList",
        component: ClaimsList,
        meta: {
          title: "退款理赔审核",
        },
      },
      {
        path: "claims/detail/:id", // 理赔详情
        name: "ClaimsDetail",
        component: ClaimsDetail,
        meta: {
          title: "理赔单详情",
        },
      },
      {
        path: "merchant-claims-order-list",
        name: "MerchantClaimsOrderList",
        component: MerchantClaimsOrderList,
        meta: {
          title: "商家发货慢-赔付单",
        },
      },
      {
        path: "merchant-claims-detail",
        name: "MerchantClaimsDetail",
        component: MerchantClaimsDetail,
        meta: {
          title: "赔付单详情",
        },
      },
      {
        path: "merchant-margin-account",
        name: "merchantMarginAccount",
        component: MerchantMarginAccount,
        meta: {
          title: "商家保证金账户",
        },
      },
      {
        path: "merchantMarginAccount/flowLog", // 保证金账户流水日志
        name: "MerchantMarginAccountFlowLog",
        component: MerchantMarginAccountFlowLog,
        meta: {
          title: "保证金账户流水日志",
        },
      },
      {
        path: "ykb_flowdetail/ykb_flowdetail_list", // 报销单支付列表
        name: "YkbFlowdetailList",
        component: YkbFlowdetailList,
        meta: {
          title: "报销单支付列表",
        },
      },
      {
        path: "payorder/payorderlist", // 银行流水
        name: "PayOrderList",
        component: PayOrderList,
        meta: {
          title: "银行转账记录",
        },
      },
      {
        path: "xhhk/freezen-list",
        name: "FreezenBillList",
        component: FreezenBillList,
        meta: {
          title: "冻结单",
        },
      },
      {
        path: "wavepicking/summarysetting", //
        name: "SummarySetting",
        component: SummarySetting,
        meta: {
          title: "汇总设置",
        },
      },
      {
        path: "xhhk/freezen-detail/:id",
        name: "FreezenBillDetail",
        component: () => import("@/pages/xhhk/FreezenBillDetail.vue"),
        meta: {
          title: "冻结单详情",
        },
      },
      {
        path: "storagebox/index",
        name: "BoxIndex",
        component: BoxIndex,
        meta: {
          title: "容器管理",
        },
      },
      {
        path: "preallot/preAllotList",
        name: "preAllotList",
        component: PreAllotList,
        meta: {
          title: "商品预配订单表",
        },
      },
      {
        path: "stock/process-base-price-configuration",
        name: "stock/process-base-price-configuration",
        component: () =>
          import(
            "@/pages/ProcessBasePriceConfiguration/ProcessBasePriceConfiguration.vue"
          ),
        meta: {
          title: "工序基础价格配置",
        },
      },
      {
        path: "stock/position-staffing",
        name: "stock/position-staffing",
        component: () =>
          import("@/pages/PositionStaffing/PositionStaffing.vue"),
        meta: {
          title: "岗位人员配置",
        },
      },
      {
        path: "stock/position-staffing-detail/:id",
        name: "stock/position-staffing-detail",
        component: () =>
          import("@/pages/PositionStaffingDetail/PositionStaffingDetail.vue"),
        meta: {
          title: "岗位人员配置明细",
        },
      },
      {
        path: "stock/shipping-order-list",
        name: "stock/shipping-order-list",
        component: () =>
          import("@/pages/ShippingOrderList/ShippingOrderList.vue"),
        meta: {
          title: "发货单列表",
        },
      },
      {
        path: "stock/edit-shipping-order/:id",
        name: "stock/edit-shipping-order",
        component: () =>
          import("@/pages/EditShippingOrder/EditShippingOrder.vue"),
        meta: {
          title: "编辑发货单",
        },
      },
      {
        path: "stock/create-shipping-order",
        name: "stock/create-shipping-order",
        component: () =>
          import("@/pages/EditShippingOrder/EditShippingOrder.vue"),
        meta: {
          title: "编辑发货单",
        },
      },
      {
        path: "stock/picking-order-list",
        name: "stock/picking-order-list",
        component: () =>
          import("@/pages/PickingOrderList/PickingOrderList.vue"),
        meta: {
          title: "拣货单列表",
        },
      },
      {
        path: "stock/picking-order-detail/:id",
        name: "stock/picking-order-detail",
        component: () =>
          import("@/pages/PickingOrderDetail/PickingOrderDetail.vue"),
        meta: {
          title: "拣货单明细",
        },
      },
      {
        path: "stock/stock-out-order-list",
        name: "stock/stock-out-order-list",
        component: () =>
          import("@/pages/stockOutOrderList/stockOutOrderList.vue"),
        meta: {
          title: "出库单列表",
        },
      },
      {
        path: "stock/stock-out-order-detail/:id",
        name: "stock/stock-out-order-detail",
        component: () =>
          import("@/pages/stockOutOrderDetail/stockOutOrderDetail.vue"),
        meta: {
          title: "出库单明细",
        },
      },
      {
        path: "stock/stock-out-order-detail/",
        name: "stock-out-order-detail-create",
        component: () =>
          import("@/pages/stockOutOrderDetail/stockOutOrderDetail.vue"),
        meta: {
          title: "出库单明细",
        },
      },
      {
        path: "stock/product-release-log",
        name: "stock/product-release-log",
        component: () =>
          import("@/pages/ProductReleaseLog/ProductReleaseLog.vue"),
        meta: {
          title: "商品出库日志",
        },
      },
      {
        path: "bulk-out-stock",
        name: "BulkOutStock",
        component: () => import("@/pages/order/BulkOutStock.vue"),
        meta: {
          title: "用户订单批量断货",
        },
      },
      {
        path: "purchase-dashboard",
        name: "purchase-dashboard",
        component: () =>
          import("@/pages/PurchaseDashboard/PurchaseDashboard.vue"),
        meta: {
          title: "代采工作台",
        },
      },
      {
        path: "pre-qc",
        name: "pre-qc",
        component: () => import("@/pages/quality/PreQcMissionList.vue"),
        meta: {
          title: "前置质检任务列表",
        },
      },
      {
        path: "pre-qc-dashboard",
        name: "PreQcDashboard",
        component: () => import("@/pages/quality/PreQcDashboard.vue"),
        meta: {
          title: "质检页面",
        },
      },
      {
        path: "pre-qc-detail",
        name: "PreQcDetail",
        component: () => import("@/pages/quality/PreQcDetail.vue"),
        meta: {
          title: "质检详情",
        },
      },
      {
        path: "stock/warehouse-list",
        name: "stock/warehouse-list",
        component: () => import("@/pages/WarehouseList/WarehouseList.vue"),
        meta: {
          title: "仓库列表",
        },
      },
      {
        path: "stock/warehouse-worker-list",
        name: "stock/warehouse-worker-list",
        component: () =>
          import("@/pages/WarehouseWorkerList/WarehouseWorkerList.vue"),
        meta: {
          title: "仓库人员管理",
        },
      },
      {
        path: "stock/salary-accounting-summary",
        name: "stock/salary-accounting-summary",
        component: () =>
          import("@/pages/SalaryAccountingSummary/SalaryAccountingSummary.vue"),
        meta: {
          title: "薪资核算汇总表",
        },
      },
      {
        path: "stock/salary-accounting-summary-detail/:id",
        name: "stock/salary-accounting-summary-detail",
        component: () =>
          import(
            "@/pages/SalaryAccountingSummaryDetail/SalaryAccountingSummaryDetail.vue"
          ),
        meta: {
          title: "薪资核算明细",
        },
      },
      {
        path: "wavepicking/summarycut",
        name: "SummaryCut",
        component: SummaryCut,
        meta: {
          title: "PC分播",
        },
      },
      {
        path: "supply/ProfileManager", //
        name: "ProfileManager",
        component: ProfileManager,
        meta: {
          title: "档口助手人员列表",
        },
      },
      {
        path: "cod/index", // 货到付款列表
        name: "CodIndex",
        component: CodIndex,
        meta: {
          title: "货到付款列表",
        },
      },
      {
        path: "scanDbidsList",
        name: "ScanDbidsList",
        component: ScanDbidsList,
        meta: {
          title: "扫码达人",
        },
      },
      {
        path: "orderStopLogList",
        name: "orderStopLogList",
        component: OrderStopLogList,
        meta: {
          title: "订单断货日志",
        },
      },
      {
        path: "cod/checkList",
        name: "CodCheckList",
        component: CodCheckList,
        meta: {
          title: "货到付款审核列表",
        },
      },
      {
        path: "UpshelfList",
        name: "UpshelfList",
        component: UpshelfList,
        meta: {
          title: "上架任务",
        },
      },
      {
        path: "cod/denyList",
        name: "CodDenyList",
        component: CodDenyList,
        meta: {
          title: "货到付款拒签列表",
        },
      },
      {
        path: "UpshelfDetail/:id", // 上架单列表
        name: "UpshelfDetail",
        component: UpshelfDetail,
        meta: {
          title: "上架单详情",
        },
      },
      {
        path: "wavepicking/devicecut",
        name: "DeviceCut",
        component: DeviceCut,
        meta: {
          title: "设备监控",
        },
      },
      {
        path: "downshelf/index",
        name: "DownshelfIndex",
        component: DownshelfIndex,
        meta: {
          title: "货位整合任务",
        },
      },
      {
        path: "OweExceptionList", // 标记异常欠货操作日志列表
        name: "OweExceptionList",
        component: OweExceptionList,
        meta: {
          title: "标记异常欠货日志",
        },
      },
      {
        path: "downshelf/detail/:id", //
        name: "DownshelfDetail",
        component: DownshelfDetail,
        meta: {
          title: "整合单详情",
        },
      },
      {
        path: "wavepicking/TempSummaryList/:id/:picking_assignment_no?", // 临时汇总
        name: "TempSummaryList",
        component: TempSummaryList,
        meta: {
          title: "临时汇总",
        },
      },
      {
        path: "wavepicking/qlsummarydetail/:id", // 汇总详情
        name: "QlSummaryDetail",
        component: QlSummaryDetail,
        meta: {
          title: "汇总详情",
        },
      },

      {
        path: "wavepicking/labelusersetting", // 改标用户汇总设置
        name: "LabelUserSetting",
        component: LabelUserSetting,
        meta: {
          title: "改标用户汇总配置",
        },
      },
      {
        path: "wavepicking/labeluserspace", //
        name: "LabelUserSpace",
        component: LabelUserSpace,
        meta: {
          title: "改标用户列表",
        },
      },
      {
        path: "wavepicking/weighturnsetting", // 称重转向配置
        name: "WeighTurnSetting",
        component: WeighTurnSetting,
        meta: {
          title: "称重转向配置",
        },
      },
      {
        path: "wavepicking/onlydabiaosetting", // PC点货分离设置
        name: "OnlyDabiaoSetting",
        component: OnlyDabiaoSetting,
        meta: {
          title: "PC点货分离设置",
        },
      },
      {
        path: "wavepicking/stockdetailseparatesetting", // 库存分离设置,
        name: "StockDetailSeparateSetting",
        component: StockDetailSeparateSetting,
        meta: {
          title: "点货库存分离设置",
        },
      },
      {
        path: "supply/packagedetail/:id", // 收包详情
        name: "PackageDetail",
        component: PackageDetail,
        meta: {
          title: "包裹点货详情",
        },
      },
      {
        path: "operaterecordexport", // 操作日志导出
        name: "OperateRecordExport",
        component: OperateRecordExport,
        mete: {
          title: "操作日志导出",
        },
      },
      {
        path: "quality/pc-trans", // PC调拨
        name: "PcTrans",
        component: PcTrans,
        meta: {
          title: "PC调拨",
        },
      },
      {
        path: "wavepicking/alertLock", // 点货弹窗锁屏配置
        name: "WavepickingAlertLock",
        component: () => import("@/pages/wavepicking/AlertLock.vue"),
        meta: {
          title: "PC点货/拆包设置",
        },
      },
      {
        path: "devicecut/cutlog", // 分播日志
        name: "DeviceCutLog",
        component: DeviceCutLog,
        meta: {
          title: "分播日志",
        },
      },
      {
        path: "wavepicking/dabiaosetting", // 点货设置
        name: "DaBiaoSetting",
        component: DaBiaoSetting,
        meta: {
          title: "点货配置",
        },
      },
      {
        path: "upshelf/upshelflog", // 上架日志
        name: "UpshelfLog",
        component: UpshelfLog,
        meta: {
          title: "商品上架日志",
        },
      },
      {
        path: "newstockdetail/stockdetaillist", // 库存明细
        name: "StockDetailList",
        component: StockDetailList,
        meta: {
          title: "商品库存明细",
        },
      },
      {
        path: "picker/importantsupplylog", // 买手绑档操作日志
        name: "ImportantSupplyLog",
        component: ImportantSupplyLog,
        meta: {
          title: "买手绑档操作日志",
        },
      },
      {
        path: "wavepicking/gridsetting", //
        name: "GridSetting",
        component: GridSetting,
        meta: {
          title: "分播机格口设置",
        },
      },
      {
        path: "adminsetting/qualitylabelsetting", // 质检改标设置
        name: "QualityLabelSetting",
        component: QualityLabelSetting,
        meta: {
          title: "质检改标配置",
        },
      },
      {
        path: "machine/machinelist", //
        name: "MachineList",
        component: MachineList,
        meta: {
          title: "分播机器列表",
        },
      },
      {
        path: "machine/machinecut", //
        name: "MachineCut",
        component: MachineCut,
        meta: {
          title: "快手分播监控",
        },
      },
      {
        path: "wavepicking/checksetting", // 波次校验设置
        name: "WaveCheckSetting",
        component: WaveCheckSetting,
        meta: {
          title: "波次校验设置",
        },
      },
      {
        path: "wavepicking/tempycspacelist", // 临时异常列表
        name: "TempYcSpaceList",
        component: TempYcSpaceList,
        meta: {
          title: "临时异常区列表",
        },
      },
      {
        path: "wavepicking/cutsetting", // 波次分播设置
        name: "WaveCutSetting",
        component: WaveCutSetting,
        meta: {
          title: "波次分播设置",
        },
      },
      {
        path: "wavepicking/wavepickinghechalog", // 波次核查日志
        name: "WavePickingHechaLog",
        component: WavePickingHechaLog,
        meta: {
          title: "波次核查列表",
        },
      },
      {
        path: "wavepicking/pdasetting", // pad设置
        name: "PdaSetting",
        component: PdaSetting,
        meta: {
          title: "PDA配置",
        },
      },
      {
        path: "inventory/list", // 盘点列表
        name: "InventoryList",
        component: InventoryList,
        meta: {
          title: "盘点列表",
        },
      },
      {
        path: "Log/PlanOperLogList", // 急救箱日志
        name: "PlanOperLogList",
        component: PlanOperLogList,
        meta: {
          title: "急救箱日志",
        },
      },
      {
        path: "inventory/detail/:inventory_id", // 盘点详情
        name: "InventoryDetail",
        component: InventoryDetail,
        meta: {
          title: "盘点详情",
        },
      },
      {
        path: "picker/anchor", //
        name: "pickerAnchor",
        component: () => import("@/pages/picker/anchor.vue"),
        meta: {
          title: "主播列表",
        },
      },
      {
        path: "inventory/inventorylog", // 盘点日志
        name: "InventoryLog",
        component: InventoryLog,
        meta: {
          title: "盘点日志",
        },
      },
      {
        path: "gaibiao/gblog", // 改标日志
        name: "GbLog",
        component: GbLog,
        meta: {
          title: "改标仓位上架日志",
        },
      },
      {
        path: "logistics/Logisticslist", // 物流公司
        name: "LogisticsList",
        component: LogisticsList,
        meta: {
          title: "物流公司",
        },
      },
      {
        path: "gaibiao/inputreocrd", // 改标录入列表
        name: "GbInputRecord",
        component: GbInputRecord,
        meta: {
          title: "改标列表",
        },
      },
      {
        path: "gaibiao/gbtypesetting", // 改标类型管理
        name: "GbTypeSetting",
        component: GbTypeSetting,
        meta: {
          title: "改标类型管理",
        },
      },
      {
        path: "gaibiao/gbusersetting", // 改标人员管理
        name: "GbUserSetting",
        component: GbUserSetting,
        meta: {
          title: "改标人员管理",
        },
      },
      {
        path: "setting/expresssize", // 快递模板设置
        name: "ExpressSizeSetting",
        component: ExpressSizeSetting,
        meta: {
          title: "快递模板管理",
        },
      },
      {
        path: "log/erperrolog", //
        name: "ErpErrorLog",
        component: ErpErrorLog,
        meta: {
          title: "错误操作记录列表",
        },
      },
      {
        path: "wavepicking/RecheckLogList", //
        name: "RecheckLogList",
        component: RecheckLogList,
        meta: {
          title: "波次核查日志",
        },
      },
      {
        path: "aspackage/aspackagelist", //
        name: "AsPackageList",
        component: AsPackageList,
        meta: {
          title: "售后收包管理",
        },
      },
      {
        path: "aspackage/aspackagedetail", //
        name: "AsPackageDetail",
        component: AsPackageDetail,
        meta: {
          title: "售后收包明细",
        },
      },
      {
        path: "setting/TallyTaskSetting", // 快递模板设置
        name: "TallyTaskSetting",
        component: TallyTaskSetting,
        meta: {
          title: "理货任务设置",
        },
      },
      {
        path: "tallytask/TallyTaskList", //
        name: "TallyTaskList",
        component: TallyTaskList,
        meta: {
          title: "理货任务列表",
        },
      },
      {
        path: "tallytask/TallyTaskDetail/:id", // 上架单列表
        name: "TallyTaskDetail",
        component: TallyTaskDetail,
        meta: {
          title: "理货任务明细",
        },
      },
      {
        path: "wavepicking/RecheckLogDetail/:id", // 上架单列表
        name: "RecheckLogDetail",
        component: RecheckLogDetail,
        meta: {
          title: "核查记录明细",
        },
      },
      {
        path: "defectivegroup",
        name: "DefectiveGroup",
        component: DefectiveGroup,
        meta: {
          title: "次品组别",
        },
      },
      {
        path: "supply/SupplyNoticeList", // 商家消息公告
        name: "SupplyNoticeList",
        component: SupplyNoticeList,
        meta: {
          title: "商家消息公告",
        },
      },
      {
        path: "supplywaitback/SupplyWaitBackList", // 商家待回货
        name: "SupplyWaitBackList",
        component: SupplyWaitBackList,
        meta: {
          title: "待回货商品前置打标",
        },
      },
      {
        path: "monitor/board",
        name: "screenboard",
        component: ScreenBoard,
        meta: {
          requireAuth: true,
          title: "监控看板",
        },
      },
      {
        path: "aspackage/aspackageintercept",
        name: "AsPackageIntercept",
        component: AsPackageIntercept,
        meta: {
          title: "售后收包拦截",
        },
      },
      {
        path: "stockin/ExchangeList",
        name: "ExchangeList",
        component: ExchangeList,
        meta: {
          title: "次品组退换货接收",
        },
      },
      {
        path: "setting/supplypackagetips",
        name: "SupplyPackageTips",
        component: SupplyPackageTips,
        meta: {
          title: "仓库收包商家提示",
        },
      },
      {
        path: "dabiao/dbidtravellog",
        name: "DbidTravelLog",
        component: DbidTravelLog,
        meta: {
          title: "商品全轨迹查询",
        },
      },
      {
        path: "express_cost",
        name: "ExpressCost",
        component: () => import("@/pages/expressCost.vue"),
        meta: {
          title: "快递费用",
        },
      },
      {
        path: "pacashlog/PaCashLogList",
        name: "PaCashLogList",
        component: PaCashLogList,
        meta: {
          title: "一手商家子账户",
        },
      },
      {
        path: "refundBill/RefundBillList",
        name: "RefundBillList",
        component: RefundBillList,
        meta: {
          title: "返还资金流水",
        },
      },
      {
        path: "merchants/index",
        name: "MerchantsIndex",
        component: MerchantsIndex,
        meta: {
          title: "意向商家列表",
        },
      },
      {
        path: "setting/goods_integration",
        name: "goodsIntegration",
        component: GoodsIntegration,
        meta: {
          title: "货位整合",
        },
      },
      {
        path: "setting/script_setting",
        name: "scriptSetting",
        component: () => import("@/pages/setting/ScriptSetting.vue"),
        meta: {
          title: "脚本配置",
        },
      },
      {
        path: "notification/news-bulletin",
        name: "news-bulletin",
        component: () => import("@/pages/NewsBulletin/NewsBulletin.vue"),
        meta: {
          title: "消息公告",
        },
      },
      {
        path: "low-performance/goods-list",
        name: "LowPerformanceGoodsList",
        component: () => import("@/pages/LowPerformance/GoodsList.vue"),
        meta: {
          title: "低履约商品列表",
        },
      },
      {
        path: "on-the-way/apply-list",
        name: "OnTheWayApplyList",
        component: () => import("@/pages/OnTheWay/ApplyList.vue"),
        meta: {
          title: "在途转欠货申请",
        },
      },
      {
        path: "on-the-way/apply-detail",
        name: "OnTheWayApplyDetail",
        component: () => import("@/pages/OnTheWay/ApplyDetail.vue"),
        meta: {
          title: "在途转欠货申请详情",
        },
      },
      {
        path: "picker/merchantOperator",
        name: "MerchantOperator",
        component: MerchantOperator,
        meta: {
          title: "商家运营人员管理",
        },
      },
      {
        path: "position-permission/positions",
        name: "Positions",
        component: Positions,
        meta: {
          title: "岗位权限配置",
        },
      },
      {
        path: "position-permission/positions/create",
        name: "PositionCreate",
        component: PositionsCreate,
        meta: {
          title: "新增岗位",
        },
      },
      {
        path: "position-permission/positions/edit/:id",
        name: "PositionEdit",
        component: PositionsCreate,
        meta: {
          title: "编辑岗位",
        },
      },
      {
        path: "purchasing/overdue",
        name: "Overdue",
        component: Overdue,
        meta: {
          title: "超3天欠货货期",
        },
      },
    ],
  },
  {
    path: "/404",
    component: () => import("@/pages/404.vue"),
    hidden: true,
  },
  { path: "*", redirect: "/404", hidden: true },
];

const allRoutes = mergeRouter(routes, [
  tallyRouter,
  preSpaceRouter,
  hotStockingRouter,
  reCommodityRouter,
  serviceOrder,
  wavePickingRouter,
  supply,
  oweReback,
  randOut,
  workRouter,
  stockDetail,
  returnOrder,
  finance,
  setting,
  task,
  afterSale,
  quality,
  warehouseTransfer,
  log,
  warehouse,
  inventory,
  goods,
  supplyNotice,
  receiveGoods,
  stock,
]);

export default allRoutes;



// WEBPACK FOOTER //
// ./src/router/router.js